import { createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';
import Types from '../Actions/Types';



export const INITIAL_STATE = Immutable({
    loaded: false,
    isLoading: false,
    childList: [],
    selectedChild: 0,

    isLoadingReportStatus: false,
    statusList: [],

    isLoadingReport: false,
    reportName: '',
    reportError: false,
    report: '',

    updateChild: {
        isUpdating: false,
        status: false,
        error: ''
    },
    dmftIndex: null,

    showStudentVerificationModal: false,
    responseCovidDeclarationForm: {
        showResponseModal: false,
        responseSuccess: false 
    }
});



const fetchingChildList = (state, action) => {
    return state.merge({
        isLoading: true
    })
}


const responseChildList = (state, action) => {
    if(!action.response.ok) {
        return state.merge({
            isLoading: false,
            loaded: false,
            childList: [],
            selectedChild: 0,
            showStudentVerificationModal: false
        })
    }

    else {
        return state.merge({
            isLoading: false,
            loaded: true,
            childList: action.response.childList,
            selectedChild: action.response.selectedChild,
            showStudentVerificationModal: action.response.showStudentVerificationModal
        })
    }
};


const updateChildSelection = (state, action) => {
    if(action.index >= 0 && action.index < state.childList.length) {
        return state.merge({
            selectedChild: action.index
        })
    }
    else {
        return state;
    }
};


const resetStudentAssessmentStatus = (state, action) => {
    return state.merge({
        isLoadingReportStatus: true,
        statusList: []
    });
};


const responseStudentAssessmentStatus = (state, action) => {
    if(action.response.ok) {
        return state.merge({
            isLoadingReportStatus: false,
            statusList: action.response.statusList
        });
    }

    else {
        return state.merge({
            isLoadingReportStatus: false,
            statusList: []
        });
    }
};


const fetchingPentahoReport = (state, action) => {
    return state.merge({
        isLoadingReport: true,
        reportName: action.reportName
    })
};


const responsePentahoReport = (state, action) => {
    if(action.response.ok) {
        return state.merge({
            isLoadingReport: false,
            reportError: false,
            report: action.response.report
        })
    }
    else {
        return state.merge({
            isLoadingReport: false,
            reportError: true,
            report: action.response.error
        })
    }
};


const updateChildUser = (state, action) => {
    if(!Boolean(action.next) || !Boolean(action.next.action)) return state;

    const type = action.next.action({}).type;

    if(type === Types.RESPONSE_UPDATE_CHILD_USER) {
        return state.merge({
            updateChild: {
                isUpdating: true,
                status: false,
                error: ''
            }
        });
    }

    else {
        return state;
    }
};


const updateChildResponse = (state, action) => {
    if(action.response.status) {
        return state.merge({
            updateChild: {
                isUpdating: false,
                status: true,
                error: ''
            }
        });
    }
    
    return state.merge({
        updateChild: {
            isUpdating: false,
            status: false,
            error: action.response.error
        }
    });
};

const updateDMFTIndex = (state, action) => {

    if(Boolean(action.dmftIndex) && !action.dmftIndex.error) {
        return state.merge({
            dmftIndex: action.dmftIndex
        })
    } else {
        return state.merge({
            dmftIndex: null
        })
    }

}

const updateSelectedChildOnUpdate = (state, action) => {

    if (action.obj.newCustom) {
        let child  = state.childList[state.selectedChild].asMutable()
        let obj = {}
        
        obj = JSON.parse(action.obj.newCustom)
        child = Object.assign({}, child, obj)

        let updated = state.childList.asMutable()
        updated[state.selectedChild] = child

        return state.merge({
        childList : updated,
        updateChild: {
                isUpdating: false,
                status: false,
                error: ''
            }
        })
    }

}

const hideStudentVerificationModal = (state, action) => {
        return state.merge({
            hideStudentVerificationModal: false
        });
};

const responseCovidDeclarationForm = (state, action) => {

    let obj 

    if (action.status) {
        obj = {
            showResponseModal: true,
            responseSuccess: true 
        }
    }else {
        obj = {
            showResponseModal: false,
            responseSuccess: false 
        }
    }

    return state.merge({responseCovidDeclarationForm: {...obj}})
    
};

const responseCovidDeclarationList = (state, action) => {

    return state.merge({responseCovidDeclarationList: action.results})
    
};

const ACTION_HANDLERS = {
    [Types.FETCH_CHILD_LIST]: fetchingChildList,
    [Types.RESPONSE_CHILD_LIST]: responseChildList,

    [Types.SELECT_CHILD]: updateChildSelection,

    [Types.FETCH_STUDENT_ASSESSMENT_STATUS]: resetStudentAssessmentStatus,
    [Types.RESPONSE_STUDENT_ASSESSMENT_STATUS]: responseStudentAssessmentStatus,

    [Types.FETCH_PENTAHO_REPORT]: fetchingPentahoReport,
    [Types.RESPONSE_PENTAHO_REPORT]: responsePentahoReport,

    [Types.UPDATE_USER]: updateChildUser,
    [Types.RESPONSE_UPDATE_CHILD_USER]: updateChildResponse,

    [Types.UPDATE_DMFT_INDEX]: updateDMFTIndex,
    [Types.UPDATE_SELECTED_CHILD_ON_UPDATE]: updateSelectedChildOnUpdate,

    [Types.HIDE_STUDENT_VERIFICATION_MODAL]: hideStudentVerificationModal,
    [Types.RESPONSE_COVID_DECLARATION_FORM]: responseCovidDeclarationForm,
    [Types.RESPONSE_COVID_DECLARATION_LIST]: responseCovidDeclarationList
};



export default createReducer(INITIAL_STATE, ACTION_HANDLERS)